import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { BYPASS_ROUTE_GUARD } from '@domgen/dgx-fe-common';
import { LoggingService } from '@domgen/dgx-fe-logging';
import { LocallyStoredRegistrationData } from '@us-registration/util-models';
import { Observable, of } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { RegistrationFacade } from '../../+state/registration.facade';

export const hasRegisteredItemGuard: CanActivateFn = (
  route
): Observable<boolean> => {
  const bypassRouteGuard = inject(BYPASS_ROUTE_GUARD);
  const registrationFacade = inject(RegistrationFacade);
  const loggingService = inject(LoggingService);
  const router = inject(Router);

  loggingService.debug('hasRegisteredItemGuard', 'Start');
  const redirectTo: string = route.data?.['redirectTo'] ?? '/';

  if (bypassRouteGuard) {
    loggingService.debug('hasRegisteredItemGuard', 'Success');
    return of(true);
  }

  return registrationFacade.hasRegisteredItem$.pipe(
    first(),
    map((hasRegisteredItem: boolean) => {
      const confirmationData: string | null =
        localStorage.getItem('confirmationData');

      if (hasRegisteredItem) {
        loggingService.debug('hasRegisteredItemGuard', 'Success');
        return hasRegisteredItem;
      }

      if (confirmationData) {
        const registeredItems: LocallyStoredRegistrationData[] =
          JSON.parse(confirmationData);
        loggingService.debug('hasRegisteredItemGuard', 'Success');
        return registeredItems.length > 0;
      }

      loggingService.debug('hasRegisteredItemGuard', 'Redirect', redirectTo);
      router.navigate([redirectTo], {
        queryParams: route.queryParams,
        replaceUrl: true,
      });

      return false;
    })
  );
};
